export const LOGIN = 'profile-login';
export const PROFILE_REFRESH = 'profile-refresh';
export const GET_LICENSES = 'profile-get-licenses';
export const GET_AUTO_PX = 'profile-get-autopx';
